import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../style/common.css';
import './POByJC.css';

const POByJC = ({ jcNumber }) => {
  const [vendors, setVendors] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (jcNumber) {
      fetchVendors(jcNumber);
    }
  }, [jcNumber]);

  const fetchVendors = async (jc) => {
    setVendors([]);
    setMaterials([]);
    setSelectedVendorId(null);
    setError('');

    try {
      const res = await axios.get(
        `https://ideatorportal.in/api/get_po_detail.php?jc_number=${jc}`
      );

      if (res.data.status === 'success') {
        if (res.data.vendors.length > 0) {
          setVendors(res.data.vendors);
        } else {
          setError('No vendors found for this JC Number.');
        }
      } else {
        setError(res.data.error || 'Something went wrong.');
      }
    } catch (err) {
      console.error(err);
      setError('Failed to fetch vendors.');
    }
  };

  const handleVendorChange = (e) => {
    const vendorId = parseInt(e.target.value);
    setSelectedVendorId(vendorId);
    const selectedVendor = vendors.find((v) => v.id === vendorId);
    setMaterials(selectedVendor?.materials || []);
  };

  const totalAmountAllVendors = vendors.reduce(
    (sum, v) => sum + Number(v.total_amount || 0),
    0
  );

  return (
    <div className="jc-details-container">
      <h2 style={{ fontSize: '1em' }}> For PO: {jcNumber}</h2>

      {vendors.length > 0 && (
        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>
          Total Amount of Material Imported: ₹{totalAmountAllVendors.toFixed(2)}
        </p>
      )}

      {error && <p className="error-msg">{error}</p>}

      {vendors.length > 0 && (
        <div className="vendor-select">
          <label>Select Vendor:</label>
          <select value={selectedVendorId || ''} onChange={handleVendorChange}>
            <option value="">-- Select Vendor --</option>
            {vendors.map((vendor) => (
              <option key={vendor.id} value={vendor.id}>
                {vendor.vendor_name} (₹{Number(vendor.total_amount).toFixed(2)})
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedVendorId && materials.length > 0 && (
        <div className="materials-table">
          <h3>Materials</h3>
          <table>
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Unit</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>GST (%)</th>
                <th>Total (₹)</th>
              </tr>
            </thead>
            <tbody>
              {materials.map((mat, index) => (
                <tr key={index}>
                  <td>{mat.item_name}</td>
                  <td>{mat.unit}</td>
                  <td>{mat.quantity}</td>
                  <td>{mat.price}</td>
                  <td>{mat.gst}</td>
                  <td>{Number(mat.total).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default POByJC;
